type FetchOptions = {
	url: string;
	options?: RequestInit;
	onAbort?: () => void | Promise<void>;
	signal: AbortSignal;
};

export async function fetchApiResponseHandler<T>({
	url,
	options = {},
	onAbort,
	signal,
}: FetchOptions): Promise<T> {
	try {
		const response = await fetch(url, {
			...options,
			// signal,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		return (await response.json()) as T;
	} catch (error) {
		if (error instanceof Error) {
			if (error.name === "AbortError" && onAbort) {
				// await onAbort();
			}
			console.error(`Request aborted: ${url}`, error.message);
		} else {
			console.error(`Unknown error fetching ${url}`);
		}
		throw error;
	}
}
